import React, { useEffect, useRef, useState } from "react";
// import Topbar from './../layouts/topbar/Topbar';
import Tabs from "@mui/material/Tabs";
import { DataGrid } from '@mui/x-data-grid';

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Button, Grid, Paper, Switch, TextareaAutosize } from "@mui/material";

import AutoComplete from "../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

import DatatableComponent from "../components/DatatableComponent.tsx";
import FilterComponents from "./components/FilterComponents.tsx";
import TextAreaComponents from "../components/TextAreaComponents/TextAreaComponents.tsx";
import StickyHeadTable from "../components/SpecificationTable/Specification.tsx";
import AddSpecification from "./components/AddSpecifications/AddSpecification.tsx";
import { useSelector, useDispatch } from "react-redux";
import CustomDataGrid from "../components/CustomDataGrid/CustomDataGrid.tsx";
import axios from "axios";
import AddItemDialogComponent from "./components/AddItemDialog.tsx";
import bin from "./../../assets/icons/recycle-binColor.png";
import searchIcon from "./../../assets/icons/searchIcon 1.png";
import filterIcon from "./../../assets/icons/filter 1.png";
import ediPencil from "./../../assets/icons/editPencil.png";
import AddMenuDialog from "./components/AddMenuDialog.tsx";
import EditItemDialog from "./components/EditItemDialog.tsx";
import FoodItemLinkDialog from "./components/FoodItemLinkDialog.tsx";
import { toast } from "react-toastify";
import SweetAlertModal from "../components/SweetAlertModal/SweetAlertModal.js";
import link from "./../../assets/icons/link.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import RightArrow from "../../assets/icons/right-arrow.png";
import LeftArrow from "../../assets/icons/left-arrow.png";
import MenuUnavailableModel from "./components/AddItem/FooditemUnavailableDialog.tsx";
import arrowUp from "../../assets/icons/arrowup.png";
import arrowDown from "../../assets/icons/arrowDown.png";
import LoadingView from "../../pages/components/LoadingView/LoadingView.js";
import { X } from "lucide-react";

function Product() {
  const [value, setValue] = React.useState(0);
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);


  const [openLinkConfirmaitonModal, setopenLinkConfirmaitonModal] =
    useState(false);
  const [openHideConfirmaitonModal, setopenHideConfirmaitonModal] =
    useState(false);
  const [openEnableConfirmaitonModal, setopenEnableConfirmaitonModal] =
    useState(false);
    const [searchQuery, setSearchQuery] = useState("");

  const [tableData, setTableData] = useState([]);
  const [dataRows, setDataRows] = useState([]);

  const errorToast = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const loadFoodData = async (props) => {
    console.log(props);
    if (props != undefined) {
      setLoading(true);
      const response = await axios.get(
        apiAddress +
        "/api/FoodItems/GetAllFoodItemByRestaurantIdandmenuId?restaurantId=" +
        Restauranttoken.id +
        "&menuId=" +
        props.id
      );
      var list = [];
      console.log(response.data);
      response.data.map((dt, i) => {
        var obj = {
          id: dt.foodItemId,
          name: dt.itemName,
          description: dt.description,
          mainsection: dt.menuName,
          section: dt.section,
          subsection: dt.subSection ? dt.subSection : "N/A",
          price: dt.itemBasePrice,
          imgurl: dt.imgurl,
          isActive: dt.isActive,
          restaurantId: Restauranttoken.id,
          menuId: props.id,
          displayOrder: dt.rank,
        };
        list.push(obj);
      });
      setDataRows(list);
      setLoading(false)
      if (list.length > 0) {
        console.log(list.length);
        console.log(list[list.length - 1].displayOrder);
        var rank = list[list.length - 1].displayOrder;

        setLastRank(rank + 1);
      } else {
        setLastRank(1);
      }
    }
  };
  const loadFoodDataByFoodItemId = async (foodItemid) => {
    var imgList = [];
    const response = await axios.get(
      apiAddress + "/api/FoodItems/GetFoodItemById?id=" + foodItemid
    );
    response.data.foodItemImageMapperList.map((d, i) => {
      imgList.push(d.itemImagePath);
    });

    var schedulers = [];
    response.data.foodItemSchedulerMapperList.map((d, i) => {
      var obj = { id: d.schedulerId };
      schedulers.push(obj);
    });
    response.data.imgaes = imgList;
    response.data.schedulers = schedulers;
    return response.data;
  };
  const [EditAdditemOpen, setEditAdditemOpen] = useState(false);
  const [FoodItemDataForEdit, setFoodItemDataForEdit] = useState();
  const onEditClick = async (props) => {
    setLoading(true);
    console.log("get id: ", props);
    var res = await loadFoodDataByFoodItemId(props);

    setFoodItemDataForEdit(res);

    setEditAdditemOpen(true);

    setLoading(false);
    
  };
  const [Loading, setLoading] = React.useState(false);
  const [selectedDataRows, setSelectedDataRows] = useState([]);
  const [selectedDataRow, setSelectedDataRow] = useState();
  const getselectedData = (data) => {
    console.log(data);
    setSelectedDataRows(data);
  };

const deleteBin = () => {
  if (selectedDataRows.length === 0) {
    toast.error("please select any Keyword", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } else {
    axios
      .put(apiAddress + "/api/FoodItems/DeleteFoodItem", selectedDataRows)
      .then((response) => {
        console.log(response.data);

        toast.success("Suuccesfully deleted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        // FIXING (new)
        setSelectedDataRows([]);   // clear selected rows
        setSelectionModel([]);     // clear DataGrid selection

        loadFoodData(selectedMenu);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setopenConfirmaitonModal(false);
};


  const [lastRank, setLastRank] = useState(1);

  const changeOrder = (props, type) => {
    console.log(props);
    console.log(type);
    setLoading(true);
    axios
      .put(
        apiAddress +
        "/api/Fooditems/updaterankfood?id=" +
        props.id +
        "&status=" +
        type
      )
      .then((response) => {
        console.log(response.data);
        setDataRows([]);
        toast.success("Successfully updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadFoodData(selectedMenu);
      });
  };

  const changeOrderByTextBox = (props, type) => {
    console.log(props.target.value);
    console.log(type);
    if (props.target.value != "") {
      const newRank = parseInt(props.target.value);
      
      // Validate input
      if (newRank <= 0) {
        toast.error("Please enter a valid rank number (greater than 0)", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      
      if (type.displayOrder === newRank) {
        toast.error("Please enter a different rank number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      
      setLoading(true);
      axios
        .put(
          apiAddress +
          "/api/Fooditems/updaterankwithtextboxfood?id=" +
          type.id +
          "&newRank=" +
          newRank
        )
        .then((response) => {
          console.log(response.data);
          setDataRows([]);
          toast.success("Successfully updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadFoodData(selectedMenu);
        })
        .catch((error) => {
          console.error("Error updating rank:", error);
          toast.error("Failed to update rank", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
   
  };
  
  //table start
  const isMobile = window.innerWidth < 768;
 const columnsdatas = [
  {
    field: 'displayOrder',
    headerName: 'Display Order',

    renderCell: (params) => {
    
      return (
        <div className='d-flex align-items-center justify-content-center' style={{ gap: "5px", width: "100%" }}>
          <span
            className={`${params.row.displayOrder == 1 ? 'deselct' : ""}`}
            style={{ cursor: "pointer", width: "20px" }}
            onClick={() => { changeOrder(params.row, 2) }}
          >
            <img src={arrowUp} style={{ width: "16px" }} />
          </span>
          <input
            type="number"
            className="form-control"
            style={{ width: "60px", height: "30px", fontSize: "0.85rem", padding: "2px 5px" }}
            defaultValue={params.row.displayOrder}
            onKeyDown={(event) => { if (event.key === "Enter") changeOrderByTextBox(event, params.row); }}
            onBlur={(event) => { if (event.target.value !== params.row.displayOrder.toString()) changeOrderByTextBox(event, params.row); }}
          />
          <span
            className={`${params.row.displayOrder == lastRank - 1 ? 'deselct' : ""}`}
            style={{ cursor: "pointer", width: "20px" }}
            onClick={() => { changeOrder(params.row, 1) }}
          >
            <img src={arrowDown} style={{ width: "16px" }} />
          </span>
        </div>
      );
    },
    align: 'center',
    headerAlign: 'center',
    width: 120, // fixed pixel width
  },
{
  field: "name",
  headerName: "Name",
  headerAlign: "center",
  width: 180,
  minWidth: 150,
  flex: 1,
  renderCell: (params) => (
    <span
      title={params.value} 
      onClick={() => onEditClick(params.row.id)}
      style={{
        cursor: "pointer",
        color: "#1976d2",
        fontWeight: 500,

        display: "block",
        width: "100%",
        textAlign: "left",      
        whiteSpace: "nowrap",    
        overflow: "hidden",       
        textOverflow: "ellipsis", 
      }}
    >
      {params.value}
    </span>
  ),
}

,
    {
    field: "actions",
    headerName: "",
    align: "center",
    headerAlign: "center",
    width: 80,
    flex: 0.3,
    renderCell: (params) => (
      <div style={{ cursor: "pointer" }} onClick={() => onEditClick(params.row.id)}>
        <img src={ediPencil} alt="edit" style={{ width: "18px" }} />
      </div>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    align: "center",
    headerAlign: "center",
    width: 200,
    minWidth: 150,
    flex: 1.2,
  },
  {
    field: "mainsection",
    headerName: "Main Section",
    align: "center",
    headerAlign: "center",
    width: 150,
    flex: 0.8,
  },
  {
    field: "section",
    headerName: "Section",
    align: "center",
    headerAlign: "center",
    width: 150,
    flex: 0.8,
  },
  {
    field: "subsection",
    headerName: "Sub Section",
    align: "center",
    headerAlign: "center",
    width: 120,
    flex: 0.5,
  },
  {
    field: "price",
    headerName: "Price",
    align: "center",
    headerAlign: "center",
    width: 100,
    flex: 0.5,
  },
  {
    field: "imgurl",
    headerName: "Image",
    align: "center",
    headerAlign: "center",
    width: 80,
    flex: 0.4,
    renderCell: (params) => (
      <img
        src={params.value}
        alt="food item"
        style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px" }}
      />
    ),
  },
  {
    field: "isActive",
    headerName: "Active",
    align: "center",
    headerAlign: "center",
    width: 100,
    flex: 0.5,
    renderCell: (params) => (
      <Switch
        checked={params.value}
        onChange={(event) => handleToggleChange(event, params.row)}
        color="primary"
        inputProps={{ "aria-label": "toggle" }}
      />
    ),
  },

];


  useEffect(() => {
    console.log(selectedDataRow);
  }, [selectedDataRow]);
  const FooditemEnabled = () => {

    if (!!selectedDataRows == false) {
      toast.error("please select any Food item", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      axios
        .put(apiAddress + "/api/FoodItems/EnableFoodItem?foodItemid=" + selectedDataRow?.id)
        .then((response) => {
          console.log(response.data);
          toast.success("FoodItem Enabled", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadFoodData(selectedMenu);
        });
    }
    setopenEnableConfirmaitonModal(false);
  }
  const FooditemDisabled = () => {
    if (!!selectedDataRows == false) {
      toast.error("please select any Food item", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      axios
        .put(apiAddress + "/api/FoodItems/DisableFoodItem?foodItemid=" + selectedDataRow?.id)
        .then((response) => {
          console.log(response.data);
          toast.success("FoodItem Disabled", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadFoodData(selectedMenu);
        });
    }
    setopenHideConfirmaitonModal(false);
  }

  //table end

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    console.log(newValue);
  };

  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);

  const addValue = (props) => {
    console.log(props);
    setAutoCompleteValue(props);
  };

  const apiAddress = process.env.REACT_APP_SECRET;
  const [tabViewItemList, settabViewItemList] = React.useState([]);

  const loadMenuData = () => {
    axios
      .get(
        apiAddress +
        "/api/menu/getallmenuwithdetails?restaurantId=" +
        Restauranttoken.id
      )
      .then((response) => {
        console.log(response.data);
        settabViewItemList(response.data);
        loadFoodData(response.data[0]);
      });
  };

  const [selectedMenu, setselectedMenu] = useState();
  const onTabClick = (data) => {
    setselectedMenu(data);
    setDataRows([]);
    loadFoodData(data);
  };
  const TabViewItem = ({ children, count, data }) => {
    console.log("count: " + count);
    console.log("value: " + value);

    return (
      <div
        onClick={() => {
          onTabClick(data);
        }}
      >
        {<div>{children}</div>}
      </div>
    );
  };

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const [openAddMenu, setopenAddMenu] = useState(false);
  const handleClickAddMenuOpen = () => {
    setopenAddMenu(true);
  };
  const handleAddMenu = (AddSectionData) => {
    setopenAddMenu(false);
    loadMenuData();
  };
  const handleAddMenuDialogData = (data) => {
    loadMenuData();
  };
  const [openAdditem, setOpenAdditem] = useState(false);
  const handleClickOpen = () => {
    setOpenAdditem(true);
  };
  const handleAddItem = (AddItemData) => {
    console.log(selectedMenu)
    console.log('hit')
    setOpenAdditem(AddItemData);
    setEditAdditemOpen(AddItemData);
    setOpenMenuUnavailableDialog(AddItemData)

     // Use the current selectedMenu or fallback to first menu
  const menuToUse = selectedMenu || tabViewItemList[0];
  if (menuToUse) {
    loadFoodData(menuToUse);
  }
    //loadFoodData(selectedMenu);
  };

  useEffect(() => {
    loadMenuData();
  }, []);

  useEffect(() => {
  if (tabViewItemList.length > 0 && !selectedMenu) {
    setselectedMenu(tabViewItemList[0]);
  }
}, [tabViewItemList]);

  const sliderRef = useRef(null);

  const handleNext = (swiperRef) => {
    swiperRef.current.swiper.slideNext();
  };

  const handlePrev = (swiperRef) => {
    swiperRef.current.swiper.slidePrev();
  };
  const [openLinkModal, setopenLinkModal] = useState(false);
  const handleLinkModel = () => {
    setopenLinkModal(true);
  };
  const hanldeLinkmodalclose = () => {
    setopenLinkModal(false);
  };

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuUnavailableDialog, setOpenMenuUnavailableDialog] = useState(false);
  const [openMenuAvailableDialog, setOpenMenuAvailableDialog] = useState(false);

  const handleToggleChange = (event, id) => {
    console.log(id)
    if (id.isActive == false) {
      setSelectedRowId(id.id);
      setOpenMenuAvailableDialog(true);
    } else {
      setOpenMenuUnavailableDialog(true);
      setSelectedRowId(id.id);
      //setSelectedDataRow(id);
    }
  };

  const MenuActivate = () => {
    console.log(selectedRowId)

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress + "/api/Fooditems/SetFooditemAvailable?FooditemId=" + selectedRowId,
      })
        .then((response) => {
          toast.success("Fooditem activated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadFoodData(selectedMenu);
        });
    }
    setOpenMenuAvailableDialog(false);
  }
   const filteredRows = dataRows.filter((item) =>
  item.name?.toLowerCase().includes(searchQuery.toLowerCase())
);;

  return (
    <div>
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to save this?"}
        open={openConfirmaitonModal}
        onyes={deleteBin}
        close={() => {
          setopenConfirmaitonModal(false);
        }}
      />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to enable this item?"}
        open={openEnableConfirmaitonModal}
        onyes={FooditemEnabled}
        close={() => {
          setopenEnableConfirmaitonModal(false);
        }}
      />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to disable this item?"}
        open={openHideConfirmaitonModal}
        onyes={FooditemDisabled}
        close={() => {
          setopenHideConfirmaitonModal(false);
        }}
      />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will activate this food item"}
        open={openMenuAvailableDialog}
        onyes={MenuActivate}
        close={() => {
          setOpenMenuAvailableDialog(false);
        }}
      />
      {tabViewItemList.length > 0 ? (
        <div className="tabview">
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="slider-container">
                <button
                  onClick={() => {
                    handlePrev(sliderRef);
                  }}
                  className="arrow-btn-food"
                >
                  <img src={LeftArrow} alt={"arrow"} />
                </button>
                <Swiper
                  spaceBetween={10}
                  slidesPerView={"auto"}
                  ref={sliderRef}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    {tabViewItemList.map((dt, i) => {
                      return (
                        // <Tab label={dt.menuName} value={i} />
                        <SwiperSlide
                          key={i}
                          style={{ width: "auto" }}
                          className={i === activeTab ? "tab-active" : ""}
                        >
                          <Tab
                            className="p-0"
                            label={
                              <TabViewItem count={i} data={dt}>
                                <div style={{ padding: '13px' }}>
                                  {dt.menuName}
                                </div>
                                
                              </TabViewItem>
                            }
                            value={i}
                            onClick={() => handleTabClick(i)}
                          />
                        </SwiperSlide>
                      );
                    })}
                  </TabList>
                </Swiper>
                <button
                  onClick={() => {
                    handleNext(sliderRef);
                  }}
                  className="arrow-btn-food"
                >
                  <img src={RightArrow} alt="arrow" />
                </button>

                <div className="mt-1 add-btn">
                  <button
                    className="btn btnAddNew"
                    onClick={handleClickAddMenuOpen}
                  >
                    + Add new
                  </button>
                </div>
              </div>
            </Box>

            {tabViewItemList.map((dt, i) => {
              return value == i ? (
                <>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    mt={2}
                    mb={2}
                    style={{ width: '100%' }}
                  >
                    <Grid item>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item>
                          <Button
                            color="primary"
                            size="medium"
                            variant="contained"
                            style={{ borderRadius: "50%", minWidth: "auto" }}
                            onClick={handleClickOpen}
                          >
                            +
                          </Button>
                        </Grid>
                        <Grid item>
                          <img
                            src={filterIcon}
                            alt=""
                            style={{ width: "1rem" }}
                          />
                        </Grid>
                        <Grid item>Add Filter</Grid>

                        <Grid item className="my-3" title="Link">
                          <div className="roundedCorner">
                            <img
                              src={link}
                              alt=""
                              style={{ width: "1rem" }}
                              onClick={() => {
                                handleLinkModel();
                              }}
                            />
                          </div>
                        </Grid>

                        <Grid item className="my-3" title="Delete">
                          <div className="roundedCorner">
                            <img
                              src={bin}
                              alt=""
                              style={{ width: "1rem" }}
                              onClick={() => {
                                selectedDataRows.length == 0
                                  ? errorToast("Please select a item")
                                  : setopenConfirmaitonModal(true);
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item></Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid
                        container
                        flexDirection={"column"}
                        alignItems={"center"}
                      >
                        <Grid item>
                          <div
                             style={{
                               display: "flex",
                               alignItems: "center",
                               gap: "6px",
                               border: "1px solid #ccc",
                               padding: "6px 10px",
                               borderRadius: "6px",
                               background: "#fff",
                             }}
                           >
                             <img
                               src={searchIcon}
                               alt=""
                               style={{ width: "1rem", opacity: 0.7 }}
                             />
                       
                       <div
  style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
  }}
>
  <input
    type="text"
    placeholder="Search..."
    style={{
      border: "none",
      outline: "none",
      fontSize: "14px",
      paddingRight: "22px", 
    }}
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />

  {searchQuery && (
    <X
      size={16}
      style={{
        position: "absolute",
        right: "4px",
        cursor: "pointer",
        color: "#888",
      }}
      onClick={() => setSearchQuery("")}
    />
  )}
</div>
                           </div>
                        </Grid>
                        <Grid item></Grid>
                      </Grid>
                    </Grid>
                  </Grid>

  <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    {dataRows.length > 0 ? (
                      selectedDataRows[value] != undefined ? (
                        <CustomDataGrid
                          columns={columnsdatas}
                        dataRows={filteredRows}

                     

                          getselectedData={getselectedData}
                          selectedRows={selectedDataRows[value]}
                          isLoading={Loading}
                        />
                      ) : (
                        <CustomDataGrid
                          columns={columnsdatas}
                          dataRows={filteredRows}
                          getselectedData={getselectedData}
                        />
                      )
                    ) : (
                      "No Data found"
                    )}
                  </Paper>

                </>
              ) : (
                ""
              );
            })}
          </TabContext>
        </div>
      ) : (
        <div className="mt-1">
          <button className="btn btnAddNew" onClick={handleClickAddMenuOpen}>
            + Add new
          </button>
        </div>
      )}
      <AddSpecification />
      {openAdditem ? (
        <AddItemDialogComponent
          open={openAdditem}
          onHandleAddItem={handleAddItem}
          selectedMenu = {selectedMenu}
        />
      ) : (
        ""
      )}
      <AddMenuDialog
        open={openAddMenu}
        onHandleAddItem={handleAddMenu}
        onHandleSelectedData={handleAddMenuDialogData}
      />
      {EditAdditemOpen && FoodItemDataForEdit && (
        <EditItemDialog
          open={EditAdditemOpen}
          onHandleAddItem={handleAddItem}
          editData={FoodItemDataForEdit}
        />
      )}

      {openMenuUnavailableDialog &&
        <MenuUnavailableModel
          open={openMenuUnavailableDialog}
          selectedMenuId={selectedRowId}
          onHandleAddItem={handleAddItem}
        //eidtData={EditMenudObj}
        />}

      <FoodItemLinkDialog
        open={openLinkModal}
        linkmodalclose={hanldeLinkmodalclose}
        Openfrom={"Main"}
      // onHandleAddItem={handleAddMenu}
      // onHandleSelectedData={handleAddMenuDialogData}
      />
    </div>
  );
}

export default Product;
